import { createFileRoute } from "@tanstack/react-router";
import { TestResultPage } from "@/routes/_main/exams/$slug/test/$id/result";

export const Route = createFileRoute("/_main/groups/$gid/exams/$slug/test/$id/result")({
  component: TestResultPage,
});
